module.exports = __webpack_public_path__ + "img/running_report_icon_w239_h245_1x.76f1c976.png";